export default "__VITE_ASSET__1zZ4aVYm__"